import { BaseService } from "../../core/baseService";
import {
  ServiceRequestServiceInterface,
  GetServiceRequestsParams,
  UpdateServiceRequestStatusParams,
} from "../types/serviceRequest.types";
import { AdminServiceRequestDto } from "../../../models/AdminServiceRequestDto";
import { PaginatedResponse } from "../../../models";
import { ApiResult, CountResponse, extractCount } from "../../core/types";

export class ServiceRequestService
  extends BaseService
  implements ServiceRequestServiceInterface
{
  async getPendingCount(): Promise<ApiResult<number>> {
    const result = await this.handleRequest<CountResponse>(
      this.client.get("/api/admin/service-requests/pending-count"),
    );
    return extractCount(result);
  }

  async getRequests(
    params: GetServiceRequestsParams,
  ): Promise<ApiResult<PaginatedResponse<AdminServiceRequestDto>>> {
    const queryParams = this.buildQueryParams({
      status: params.status,
      roomNumber: params.roomFilter,
      pageNumber: params.page,
      pageSize: params.pageSize,
    });

    return this.handleRequest<PaginatedResponse<AdminServiceRequestDto>>(
      this.client.get("/api/admin/service-requests", { params: queryParams }),
    );
  }

  async updateStatus(
    params: UpdateServiceRequestStatusParams,
  ): Promise<ApiResult<AdminServiceRequestDto>> {
    const { serviceRequestId, status, adminNotes } = params;

    return this.handleRequest<AdminServiceRequestDto>(
      this.client.put(
        `/api/admin/service-requests/${serviceRequestId}/status`,
        {
          status: status,
          notes: adminNotes || null,
        },
      ),
    );
  }
}
